import React from 'react'
import { Card, Col, Row, Statistic, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import styled from 'styled-components'

interface Performance {
  avgProcessingDays: number | null
  rejectionRate: number | null
  avgClientWaitDays: number | null
  avgEffectiveWorkDays: number | null
  avgAuthorityWaitDays: number | null
}

interface Props {
  performance: Performance
}

const PerformanceMetrics = ({ performance }: Props) => (
  <Card title="Métriques de performance" style={{ borderRadius: 8 }}>
    <Row gutter={[24, 16]}>
      <Col xs={24} sm={12}>
        <MetricCard>
          <Statistic
            title={
              <span>
                Délai moyen de traitement&nbsp;
                <Tooltip title="Durée moyenne entre la complétion du dossier et la validation par l'autorité légale">
                  <InfoCircleOutlined style={{ color: '#aaa' }} />
                </Tooltip>
              </span>
            }
            value={performance.avgProcessingDays ?? '—'}
            suffix={performance.avgProcessingDays != null ? 'jours' : ''}
            valueStyle={{ color: '#1890ff' }}
          />
        </MetricCard>
      </Col>
      <Col xs={24} sm={12}>
        <MetricCard>
          <Statistic
            title={
              <span>
                Taux de rejet&nbsp;
                <Tooltip title="Pourcentage de dossiers renvoyés en statut refusé par le Greffe / INPI">
                  <InfoCircleOutlined style={{ color: '#aaa' }} />
                </Tooltip>
              </span>
            }
            value={performance.rejectionRate ?? '—'}
            suffix={performance.rejectionRate != null ? '%' : ''}
            valueStyle={{
              color:
                performance.rejectionRate != null &&
                performance.rejectionRate > 20
                  ? '#ff4d4f'
                  : '#52c41a',
            }}
          />
        </MetricCard>
      </Col>
    </Row>

    <Row gutter={[24, 16]} style={{ marginTop: 16 }}>
      <Col xs={24} sm={8}>
        <MetricCard>
          <Statistic
            title={
              <span>
                Délai attente client&nbsp;
                <Tooltip
                  title="Durée moyenne entre la réception du formulaire et le dépôt de capital
                  (si applicable) ou la mise en signature"
                >
                  <InfoCircleOutlined style={{ color: '#aaa' }} />
                </Tooltip>
              </span>
            }
            value={performance.avgClientWaitDays ?? '—'}
            suffix={performance.avgClientWaitDays != null ? 'jours' : ''}
            valueStyle={{ color: '#faad14' }}
          />
        </MetricCard>
      </Col>
      <Col xs={24} sm={8}>
        <MetricCard>
          <Statistic
            title={
              <span>
                Temps de travail effectif&nbsp;
                <Tooltip
                  title="Somme des durées où le juriste travaille activement :
                    complétion→instruction + instruction→dépôt de capital demandé
                    (ou →signature si sans capital) + capital déposé→signature (si applicable) + signée→greffe"
                >
                  <InfoCircleOutlined style={{ color: '#aaa' }} />
                </Tooltip>
              </span>
            }
            value={performance.avgEffectiveWorkDays ?? '—'}
            suffix={performance.avgEffectiveWorkDays != null ? 'jours' : ''}
            valueStyle={{ color: '#722ed1' }}
          />
        </MetricCard>
      </Col>
      <Col xs={24} sm={8}>
        <MetricCard>
          <Statistic
            title={
              <span>
                Délai traitement greffe&nbsp;
                <Tooltip
                  title="Durée moyenne du traitement de la formalité
                par le greffe (dépôt → validation par le greffe)"
                >
                  <InfoCircleOutlined style={{ color: '#aaa' }} />
                </Tooltip>
              </span>
            }
            value={performance.avgAuthorityWaitDays ?? '—'}
            suffix={performance.avgAuthorityWaitDays != null ? 'jours' : ''}
            valueStyle={{ color: '#13c2c2' }}
          />
        </MetricCard>
      </Col>
    </Row>
  </Card>
)

export default PerformanceMetrics

const MetricCard = styled.div`
  padding: 16px;
  background: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
`
